(function($, duo, undefined){

  "use strict";

  /**
  * @class SmoothScroll
  */
  class SmoothScroll {

    /**
    * Creates an instance of SmoothScroll -
    * using the contructor will add smooth scroll functionality to all links provided in the selector
    * @param selector css selector of the element to attach click handler to
    * @param scrollSpeed length of the scroll animation (in milliseconds)
    * @param useConstantScrollSpeed defaults to false
    * @param scrollAccelerator base speed (in milliseconds) divided by a base length, used if useConstantScrollSpeed is set to true
    */
    constructor({selector = 'a[href*="#"]:not([href="#"])', scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100), moveFocus = true } = {}) {
      this.selector = selector;

      this.scrollSpeed = scrollSpeed;
      this.useConstantScrollSpeed = useConstantScrollSpeed;
      this.scrollAccelerator = scrollAccelerator;
      this.moveFocus = moveFocus;

      // setup click event handler:
      this._setEventHandlers();
    } /* constructor */

    /**
    * Setup click handler for smooth scroll links
    */
    _setEventHandlers() {
      const smoothscroll = this;

      $(document).on('click.SmoothScroll', smoothscroll.selector, function(e) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);

          if (target.length) {
            duo.SmoothScroll._doScroll(target, { 
              scrollSpeed: smoothscroll.scrollSpeed, 
              useConstantScrollSpeed: smoothscroll.useConstantScrollSpeed, 
              scrollAccelerator: smoothscroll.scrollAccelerator,
              moveFocus: smoothscroll.moveFocus
            });
            return false;
          }

        }
      });
    } /* _setEventHandlers */

    /**
    * Static function to scroll to an element on the page
    */
    static scrollTo($scrollTargetElement, { scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100), moveFocus = true } = {}) {
      this._doScroll($scrollTargetElement, { scrollSpeed, useConstantScrollSpeed, scrollAccelerator, moveFocus });
    }

    /**
    * Private scroll function
    */
    static _doScroll($scrollTargetElement, { scrollSpeed = 1000, useConstantScrollSpeed = false, scrollAccelerator = (60/100), moveFocus = true } = {}) {
      let scrollOffset = $scrollTargetElement.offset().top;

      // correct the scrollOffset if there is a sticky top header:
      const $siteHeader = $('.site-header');
      if($siteHeader.length > 0) {
        const siteHeaderStyle = getComputedStyle($siteHeader[0]);
        const computedPosition = siteHeaderStyle.position;
        const computedTop = siteHeaderStyle.top;
        if(computedPosition === 'sticky' && computedTop === '0px') {
          const siteHeaderHeight = $siteHeader.height();
          scrollOffset = scrollOffset - siteHeaderHeight;
        }
      }

      if(duo.Utils.prefersReducedMotion()) {

        // move:
        $('html, body').scrollTop(scrollOffset);

        // focus the target element:
        if(moveFocus) {
          $scrollTargetElement.focus();
          if ($scrollTargetElement.is(":focus")) {
            return false;
          } else {
            $scrollTargetElement.attr('tabindex','-1');
            $scrollTargetElement.focus();
          }
        }

      } else {

        // calculate scroll speed:
        if(useConstantScrollSpeed && scrollAccelerator !== undefined) {
          const currentScrollOffset = $(window).scrollTop();
          const heightDifference = Math.abs(currentScrollOffset - scrollOffset);
          scrollSpeed = Math.round(heightDifference * scrollAccelerator);
        }

        $('html, body').on('mousedown wheel DOMMouseScroll mousewheel touchmove', function() {
          $('html, body').stop();
        });

        $('html, body').animate({
          scrollTop: scrollOffset
        }, scrollSpeed, function() {
          $('html, body').off('mousedown wheel DOMMouseScroll mousewheel touchmove');
  
          // focus the target element:
          if(moveFocus) {
            $scrollTargetElement.focus();
            if ($scrollTargetElement.is(":focus")) {
              return false;
            } else {
              $scrollTargetElement.attr('tabindex','-1');
              $scrollTargetElement.focus();
            }
          }
        });

      }
    } /* _doScroll */

  } /* SmoothScroll */

  duo.SmoothScroll = SmoothScroll;

})(jQuery, window.duo = window.duo || {});
